<template>
  <li class="dropdown messages-menu">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
      <i class="fa fa-exclamation-triangle"></i>
      <span class="label label-warning">{{ qtfFalhas }}</span>
    </a>
    <ul class="dropdown-menu">
      <li class="header">Foram identificadas {{ qtfFalhas }} falha(s)</li>
      <li v-if="Falhas.length > 0">
        <!-- inner menu: contains the messages -->
        <ul class="menu">
          <message-item v-for="(message, key) in Falhas"
              :key="key"
              :message="message"></message-item>
        </ul>
        <!-- /.menu -->
      </li>
      <li class="footer" v-if="userInfo.messages.length > 0">
        <a href="javascript:;">Fechar</a>
      </li>
    </ul>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import MessageItem from './MessageItem'
import {firebaseApp} from '../../helpers/firebaseApp'

var db = firebaseApp.database()

export default {
  name: 'MessagesMenu',
  components: {
    MessageItem
  },
  firebase: {
    registros: db.ref('sd032021')
  },
  data () {
    return {
      registros: []
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    Falhas () {
      let arrayFalhas = []
      this.registros.forEach(element => {
        if (element.is_alarme && element.valor !== 0) {
          arrayFalhas.push(element)
        }
      })
      return arrayFalhas
    },
    qtfFalhas () {
      return this.Falhas.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// MessagesMenu.vue?3d5c8e9c